<template>
  <div id="app" :style="{marginTop}">
    <my-header v-if="this.$route.path!=='/login' && !isJida"></my-header>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      marginTop: '0px'
    }
  },
  computed: {
    ...mapGetters({  //这里的...不是省略号了,是对象扩展符
      isJida: 'isJida'
    })
  },
  watch: {
    isJida: {
      handler(newValue) {
        if (newValue) this.marginTop = '-85px'
      },
      immediate: true
    }
  }
}
</script>

<style>
#app {
  font-family: 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  background: #0aaade1c;
}
</style>



// WEBPACK FOOTER //
// src/App.vue